declare global {
  interface Window {
    tms: any;
    GUTtrack: any;
  }
}

export enum AnalyticsAction {
  PAGE_NAME = 'pageName',
  GENERAL_EVENT = 'generalEvent',
  DOWNLOAD_EVENT = 'downloadEvent',
  SYSTEM_EVENT = 'systemEvent',
  ERROR = 'errorEvent'
}

export enum AnalyticsPage {
  //IREBAL_LOGIN = "irebal:login",
  IREBAL_HOME = 'dashboard',
  IREBAL_CASH_REPORT = "cash_report",
  IREBAL_ALLOCATION_REPORT = "allocation_report",
  IREBAL_PORTFOLIO = "portfolios",
  //IREBAL_EDIT_PORTFOLIO = "irebal:edit portfolio",
  //IREBAL_EDIT_MULTIPLE_PORTFOLIOS = "irebal:edit multiple portfolios",
  IREBAL_ACCOUNTS = "accounts",
  //IREBAL_EDIT_ACCOUNT = "irebal:accounts:edit account",
  //IREBAL_EDIT_MULTIPLE_ACCOUNTS = "irebal:accounts:edit multiple accounts",
  IREBAL_UNASSIGNED_ACCOUNTS = "unassigned_accounts",
  IREBAL_MODELS = "models",
  // IREBAL_MODELS_EDIT_SECURITY_MODEL = "irebal:models:edit a security model",
  // IREBAL_MODELS_EDIT_BLENDED_MODEL = "irebal:models:edit a blended model",
  IREBAL_MODEL_MARKET_CENTER = "mmc",
  // IREBAL_MODEL_MARKET_CENTER_DETAIL = "irebal:model market center:model detail",
  // IREBAL_SECURITIES = "irebal:securities",
  // IREBAL_SECURITIES_EDIT = "irebal:securities:edit security",
  IREBAL_CREATE_REBALANCE = "full_rebal_flow",
  // IREBAL_REBALANCE_RESULTS = "irebal:rebalance results",
  IREBAL_REBALANCE_RESULT_SUMMARY = "rebal_result_summary",
  IREBAL_PORTFOLIO_RESULT_DETAIL = "port_result_detail",
  IREBAL_AUTO_REBALANCE_REPORT = "auto_rebalance_report"
  // IREBAL_SCHEDULED_REBALANCES = "irebal:scheduled rebalances",
  // IREBAL_SCHEDULED_REBALANCES_EDIT = "irebal:scheduled rebalances:edit scheduled rebalance",
  // IREBAL_ORDER_BLOTTER_ACTIVE = "irebal:order blotter:active",
  // IREBAL_ORDER_BLOTTER_ACTIVE_TRADE_DETAILS = "irebal:order blotter:active:trade details",
  // IREBAL_ORDER_BLOTTER_CLOSED = "irebal:order blotter:closed",
  // IREBAL_ORDER_BLOTTER_CLOSED_TRADE_DETAILS = "irebal:order blotter:closed:trade details",
  // IREBAL_GLOBAL_SETTINGS_SECURITIES = "irebal:global settings:securities",
  // IREBAL_GLOBAL_SETTINGS_ACCOUNTS = "irebal:global settings:accounts",
  // IREBAL_GLOBAL_SETTINGS_PORTFOLIOS = "irebal:global settings:portfolios",
  // IREBAL_GLOBAL_SETTINGS_MODELS = "irebal:global settings:models",
  // IREBAL_GLOBAL_SETTINGS_REBALANCING = "irebal:global settings:rebalancing",
  // IREBAL_GLOBAL_SETTINGS_TRADING = "irebal:global settings:trading"


}

export interface PageEventArguments {
  actionName: AnalyticsAction.PAGE_NAME;
  context: '';
  details: [AnalyticsPage];
}

export interface GeneralEventArguments {
  actionName: AnalyticsAction.GENERAL_EVENT;
  context?: '';
  details: any[];
}

export interface DownloadEventArguments {
  actionName: AnalyticsAction.DOWNLOAD_EVENT;
  context?: '';
  details: any[];
}

export interface SystemEventArguments {
  actionName: AnalyticsAction.SYSTEM_EVENT;
  context?: '';
  details: any[];
}

export interface ErrorEventArguments {
  actionName: AnalyticsAction.SYSTEM_EVENT;
  browserUrl: string;
  errorstatus?: string;
  errormessage: string;
}

export type AnalyticsArguments
  = PageEventArguments
  | GeneralEventArguments
  | DownloadEventArguments
  | SystemEventArguments;

/*export const analytics = {
  track(args: AnalyticsArguments) {
    const dummy = window._tdaTrackAnalytics && window._tdaTrackAnalytics({
      eventName: 'clickstreamPost',
      eventData: {
        'actionName': args.actionName,
        'context': args.context,
        'details': args.details
      },
      eventCaller: this
    });
  }
};*/
